export const ADD_TO_COMMITTEE_START = 'ADD_TO_COMMITTEE_START';
export const ADD_TO_COMMITTEE_SUCCESS = 'ADD_TO_COMMITTEE_SUCCESS';
export const ADD_TO_COMMITTEE_ERROR = 'ADD_TO_COMMITTEE_ERROR';
